import React from "react";

const Policy = () => {
  return (
    <div>
      <br /><br />
      RockReach隱私權政策
      <br /><br />
      本隱私權政策說明在您造訪或透過「RockReach」(以下簡稱「本網站」)
      購物時，我們如何收集、使用和分享您的個人資訊。
      <br /><br />
      我們會在您造訪本網站時，自動收集與您裝置相關的特定資訊，包括您網頁瀏覽器、IP
      位址、時區和裝置上安裝之部分 Cookie
      的相關資訊。在您瀏覽本網站時，我們也會收集與以下項目相關的資訊：您檢視的個別網頁或產品、將您轉介來造訪本網站的網站或搜尋詞彙，以及您與本網站互動的方式。我們將這類自動收集的資訊稱為「裝置資訊」。
      <br /><br />
      我們用來收集裝置資訊的技術如下：
      <br />
      -「Cookie」是置於您裝置或電腦上的資料檔案，通常會包含經匿名處理的專屬識別碼。如需有關
      Cookie 及其停用方式的詳細資訊，請造訪 http://www.allaboutcookies.org。
      <br /><br />
      -「記錄檔」，用於追蹤本網站上發生的動作並收集資料，包括您的 IP
      位址、瀏覽器類型、網際網路服務供應商、推薦/離開頁面，以及日期/時間戳記。
      <br /><br />
      -「Web
      指標」、「標籤」和「像素」等電子檔，用來記錄您瀏覽本網站方式的相關資訊。
      <br /><br />
      此外，您透過本網站購物或嘗試購物時，我們會向您收集某些資訊，包括您的姓名、帳單地址、運送地址、付款資訊
      (包括信用卡號碼)、電子郵件地址和電話號碼。我們將這類資訊稱為「訂單資訊」。
      <br /><br />
      本隱私權政策中所提到的「個人資訊」，指的是裝置資訊與訂單資訊。
      <br /><br />
      我們如何使用您的個人資訊？
      <br />
      我們收集的訂單資訊一般是用來完成透過本網站所建立之任何訂單的出貨作業，包括處理您的付款資訊、安排運送，以及提供發票和/或訂單確認給您。此外，我們也會將此訂單資訊用於：
      與您通訊；審查訂單是否存在任何潛在風險或詐騙情況；以及依據您與我們分享的偏好設定，為您提供與我們產品或服務相關的資訊或廣告。
      <br />
      我們收集裝置資訊的立意在於用來輔助審查是否存在任何潛在風險和詐騙情況
      (尤其是您的 IP 位址)，而在一般情況下會用來最佳化並提升本網站
      (例如針對顧客瀏覽及顧客與本網站互動的方式進行相關分析，以及評估行銷和廣告行銷活動的成效)。
      <br /><br />
      分享您的個人資訊
      <br />
      我們會與第三方分享您的個人資訊，以利我們基於上述用途使用您的個人資訊。
      <br />
      最後，我們可能也會為了遵循適用法律和法規、回應傳票、搜查令或其他依法提出之資訊要求，或因維護自身權利所需，分享您的個人資訊。
      <br /><br />
      行為廣告
      <br />
      如上所述，我們會使用您的個人資訊，提供我們認為您可能感興趣的目標式廣告或行銷訊息。
      <br /><br />
      請勿追蹤
      <br />
      請注意，即便您的瀏覽器發出「不追蹤」訊號，我們網站的資料收集和使用方式依然不變。
      <br /><br />
      您的權利
      <br />
      如果您是歐洲居民，則有權存取我們持有之與您相關的個人資訊，並可要求修正、更新或刪除您的個人資訊。若要行使此權利，請透過下列聯絡資訊與我們聯絡。
      此外，如果您是歐洲居民，我們會注意基於履行我們可能已與您簽訂的合約
      (例如，如果您透過本網站下單)，或追求上列合法商業利益之目的處理您的資料。同時也請注意，您的資訊會傳輸到歐洲境外，包括加拿大和美國。

      <br />
      <br />
      資料保留
      <br />
      我們會在您透過本網站下單時留存您的訂單資訊，以做記錄，直到您要求我們刪除這類資訊為止。
      <br />
      <br />
      變更
      <br />
      我們可不定期變更本隱私權政策，來反映做法異動或因應其他營運、法律或法規理由等情況做出修正。
      <br />
      <br />
      聯絡我們
      <br />
      如果您需要有關隱私權做法的詳細資訊、有任何問題或想要進行投訴，請透過電子郵件
      (no30131@gmail.com) 與我們聯絡。
      <br />
      <br />
    </div>
  );
};
export default Policy;
